import { useMemo } from 'react'
import useCookie from 'src/hooks/useCookie'
import { AppTokens } from 'src/state/authentication/types'

const STORAGE_KEY = 'LEXON_APP_TOKENS'

export default function useQueryToken(): AppTokens | null {
  const queryParams = useMemo(() => {
    const params = new URLSearchParams(window.location.search)
    const result: Record<string, string> = {}
    params.forEach((value, key) => {
      result[key] = value
    })
    return result
  }, [])
  const { removeLexnetCookie } = useCookie()

  const appTokens = useMemo(() => {
    const { token, refreshToken, ...rest } = queryParams
    if (queryParams.token) {
      removeLexnetCookie()
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ token, refreshToken }))
      window.location.search = new URLSearchParams(rest).toString()
    } else {
      const appTokensFromStorage = window.sessionStorage.getItem(STORAGE_KEY)
      return appTokensFromStorage ? JSON.parse(appTokensFromStorage) : null
    }
    return null
    // eslint-disable-next-line
  }, [queryParams])

  return appTokens
}
